import React from 'react'
import { Text } from 'react-native'

import { Stack } from '@zet/design-system'

const CardTitle = ({ title }: { title: string }) => {
  return (
    <Stack className="my-4/2 mx-3">
      <Text className="font-[Graphie-Bold]  text-lg leading-7">{title}</Text>
    </Stack>
  )
}

export default CardTitle
